import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bodywork-type-field',
  templateUrl: './bodywork-type-field.component.html',
  styleUrls: ['./bodywork-type-field.component.scss']
})
export class BodyworkTypeFieldComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
